import { queryOptions, useQuery } from '@tanstack/react-query';

import { api } from 'lib/api-client';
import { QueryConfig } from 'lib/react-query';
import { LegalDocument, LegalDocumentType } from 'types/api';
import { env } from 'config/env';
import { http, HttpResponse } from 'msw';

type GetLegalDocumentResponse = {
    document: LegalDocument;
};

type GetLegalDocumentParams = {
    document_type: LegalDocumentType;
};

export const getLegalDocument = async (
    params: GetLegalDocumentParams,
): Promise<LegalDocument> => {
    const response = await api.get<
        GetLegalDocumentResponse,
        GetLegalDocumentResponse
    >(`/public/api/v1/legal/document`, {
        params,
    });
    return response.document;
};

export const getLegalDocumentQueryOptions = (
    params: GetLegalDocumentParams,
) => {
    return queryOptions({
        queryKey: ['legal-document', params.document_type],
        queryFn: () => getLegalDocument(params),
    });
};

type UseLegalDocumentOptions = {
    params: GetLegalDocumentParams;
    queryConfig?: QueryConfig<typeof getLegalDocumentQueryOptions>;
};

export const useLegalDocument = ({
    params,
    queryConfig,
}: UseLegalDocumentOptions) => {
    return useQuery({
        ...getLegalDocumentQueryOptions(params),
        ...queryConfig,
    });
};

export const getLegalDocumentMSWHandler = (legalDocument: LegalDocument) => {
    return http.get(`${env.API_URL}/public/api/v1/legal/document`, () => {
        return HttpResponse.json({ document: legalDocument });
    });
};
